import {useQuery} from "@tanstack/react-query";
import {callGetTimeTable, StaffResponse, TimeTableResponse} from "../api/timeTable";
import {useGetSemesterIdFromUrl} from "./semesterMiddleware";
import {useGetClassIdFromUrl} from "./classesMiddleware";
import {mapTimeTableResponseToTimeTable} from "./mapper/timeTableMapper";
import {RoomResponse} from "../api/rooms";
import {ClassesResponse} from "../api/classes";

export interface TimeTable {
    readonly days: Day[]
}

export interface Day {
    readonly index: number,
    readonly activities: Activity[]
}

export interface Activity {
    readonly id: string,
    readonly name: string,
    readonly description: string,
    readonly classes: string,
    readonly classesInfo: ClassesResponse[],
    readonly room: string
    readonly roomInfo: RoomResponse[],
    readonly lecturer: string,
    readonly lecturerInfo: StaffResponse[],
    readonly type: string,
    readonly tag: string,
    readonly startTime: string,
    readonly endTime: string,
    readonly weeks: number[]
}

export const useGetTimetable = () => {
    const {semesterId = ""} = useGetSemesterIdFromUrl();
    const {classId = ""} = useGetClassIdFromUrl();

    return useQuery<TimeTable | undefined>({
        queryKey: ["timeTable", semesterId, classId],
        queryFn: async () => {
            if (semesterId === "" || classId === "") {
                // Return empty TimeTable object instead of undefined to prevent query errors
                return Promise.resolve({days: []});
            }
            const response = await callGetTimeTable(semesterId, classId);
            return mapTimeTableResponseToTimeTable(response.data);
        }
    })
}

export const useGetTimetableRaw = () => {
    const {semesterId = ""} = useGetSemesterIdFromUrl();
    const {classId = ""} = useGetClassIdFromUrl();

    return useQuery<TimeTableResponse | undefined>({
        queryKey: ["timeTableRaw", semesterId, classId],
        queryFn: async () => {
            if (semesterId === "") {
                // Return empty response instead of undefined
                return Promise.resolve({days: []});
            }

            const response = await callGetTimeTable(semesterId, classId);
            return response.data;
        }
    })
}